export const CLOSE_LABEL = 'Close';
export const OPEN_LABEL = 'Open';
